import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithExcelTable } from "slices/excelTable/utils";

import {
  cloneWatchwordsList,
  fetchWatchwordsListById,
  saveWatchwordsList,
  setEmptyWatchwordList,
} from "./actions";

const mergeListIntoState = (state, { payload }) => {
  const { currentUser, data } = payload || {};
  state.data = data || null;

  if (data?.lockedBy === currentUser) {
    state.isEditing = true;
  }
};

export const INITIAL_STATE = {
  data: null,
  isDirty: false,
  isEditing: false,
  showReplaceWithPanel: false,
};

export const editWatchwordsSlice = createSlice({
  name: "edit",
  initialState: INITIAL_STATE,
  reducers: {
    resetEdit: () => INITIAL_STATE,
    setIsDirty: (state, { payload }) => {
      state.isDirty = Boolean(payload);
    },
    setIsDefault: (state, { payload }) => {
      if (state.data) {
        state.data.default = Boolean(payload);
      }
    },
    setIsEditing: (state, { payload }) => {
      state.isEditing = Boolean(payload);
    },
    setShowReplaceWithPanel: (state, { payload }) => {
      state.showReplaceWithPanel = Boolean(payload);
    },
    setDataAsLocked: (state, { payload }) => {
      const { lockedBy = null, lockedByAnotherUser = false } = payload;

      if (state.data) {
        state.data.lockedBy = lockedBy;
        state.data.lockedByAnotherUser = lockedByAnotherUser;
      }
    },
    updateDataByKey: (state, { payload }) => {
      const { key, value } = payload;

      state.isDirty = true;
      state.data = { ...state.data, [key]: value };
    },
    ...extendSliceWithExcelTable({
      rootPath: ["data", "categories"],
      onStateUpdated: (state) => {
        state.isDirty = true;
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(cloneWatchwordsList.fulfilled, mergeListIntoState);
    builder.addCase(fetchWatchwordsListById.fulfilled, mergeListIntoState);

    builder.addCase(setEmptyWatchwordList.fulfilled, (state, { payload }) => {
      state.data = payload || null;
      state.isEditing = true;
    });
    builder.addCase(saveWatchwordsList.fulfilled, (state, { payload }) => {
      if (payload) {
        state.data = payload;
        state.isDirty = false;
        state.isEditing = false;
      }
    });
  },
});

export const {
  resetEdit,
  setIsDefault,
  setIsDirty,
  setIsEditing,
  setShowReplaceWithPanel,
  setDataAsLocked,
  updateDataByKey,
  updateAllItems,
  updateItemByPath,
  removeItemByPath,
  addCategoryByIndex,
  addChildByPath,
} = editWatchwordsSlice.actions;
